export const GET_CURRENCIES = 'GET_CURRENCIES';
export const RES_GET_CURRENCIES = 'RES_GET_CURRENCIES';
export const GET_MERCHANT = 'GET_MERCHANT';
export const RES_GET_MERCHANT = 'RES_GET_MERCHANT';